"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[690],{

/***/ 78690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(45258);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Menu.js
var Menu = __webpack_require__(41587);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/logo.svg
var logo = __webpack_require__(49283);
;// CONCATENATED MODULE: ./public/logo-white.svg
/* harmony default export */ var logo_white = ({"src":"/_next/static/media/logo-white.9727d2a2.svg","height":141,"width":114});
// EXTERNAL MODULE: ./components/ui/links/CustomA.tsx
var CustomA = __webpack_require__(70378);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./utils/hooks/useWidth.ts


var useWidth = function() {
    var theme = (0,useTheme/* default */.Z)();
    var keys = (0,_to_consumable_array/* default */.Z)(theme.breakpoints.keys).reverse();
    return keys.reduce(function(output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up(key));
        return output === "xs" && matches ? key : output;
    }, "xs") || "xs";
};

;// CONCATENATED MODULE: ./components/layout/Shared/LinkedLogo.tsx








var LinkedLogo = function(param) {
    var _white = param.white, white = _white === void 0 ? false : _white, heigth = param.heigth, _width = param.width, width = _width === void 0 ? 122 : _width;
    var mq = useWidth();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: white ? logo_white : logo/* default */.Z,
                alt: "Totem logo",
                height: heigth || (mq === "xs" || mq === "sm" ? 90 : 151),
                width: width
            })
        })
    });
};
/* harmony default export */ var Shared_LinkedLogo = (LinkedLogo);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Badge/Badge.js
var Badge = __webpack_require__(59009);
// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var client = __webpack_require__(46829);
;// CONCATENATED MODULE: ./public/icons/shopping-cart.svg
/* harmony default export */ var shopping_cart = ({"src":"/_next/static/media/shopping-cart.217ced78.svg","height":450,"width":450});
// EXTERNAL MODULE: ./utils/apollo/vars/cartVar.ts
var cartVar = __webpack_require__(87543);
;// CONCATENATED MODULE: ./components/cart/CartHeaderIcon.tsx







var CartHeaderIcon = function(param) {
    var onClick = param.onClick, _className = param.className, className = _className === void 0 ? "" : _className;
    var classes = useStyles();
    var cartItems = (0,client.useReactiveVar)(cartVar/* cartVar */.FU);
    var numberOfItems = (0,react.useMemo)(function() {
        return cartItems.reduce(function(acc, param) {
            var quantity = param.quantity;
            return acc + quantity;
        }, 0);
    }, [
        cartItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        "aria-label": "cart",
        color: "primary",
        onClick: onClick,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
            badgeContent: numberOfItems,
            color: "secondary",
            invisible: !numberOfItems,
            max: 99,
            classes: {
                badge: classes.badge
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: shopping_cart,
                alt: "Cart",
                height: 28,
                width: 29
            })
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        badge: {
            color: theme.palette.common.white
        }
    };
});
/* harmony default export */ var cart_CartHeaderIcon = (CartHeaderIcon);

// EXTERNAL MODULE: ./domain/constants/NAV_LINKS.ts
var NAV_LINKS = __webpack_require__(47215);
;// CONCATENATED MODULE: ./components/layout/Shared/NavItems.tsx









var NavItems = function(param) {
    var inDrawer = param.inDrawer, onOpenCart = param.onOpenCart;
    var classes = NavItems_useStyles();
    var pathname = (0,router.useRouter)().pathname;
    var isActive = function(href) {
        return pathname.includes(href);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: classnames_default()(classes.container, inDrawer && classes.containerInDrawer),
        children: [
            NAV_LINKS/* NAV_LINKS.map */.q.map(function(param) {
                var href = param.href, title = param.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: href,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: classnames_default()(classes.item, inDrawer && classes.itemInDrawer),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            className: classnames_default()(classes.title, isActive(href) && classes.activeItem),
                            children: title
                        })
                    })
                }, href);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_CartHeaderIcon, {
                onClick: onOpenCart,
                className: classnames_default()(inDrawer && classes.cartIconInDrawer)
            })
        ]
    });
};
var NavItems_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: (0,_define_property/* default */.Z)({
            display: "none",
            alignItems: "center"
        }, theme.breakpoints.up("md"), {
            display: "flex",
            justifyContent: "space-between",
            flexGrow: 1,
            maxWidth: "none",
            paddingLeft: 0,
            paddingRight: 0
        }),
        item: {
            textDecoration: "none",
            marginRight: theme.spacing(4),
            "&:hover": {
                textDecoration: "none",
                color: theme.palette.primary.main
            }
        },
        title: (0,_define_property/* default */.Z)({
            textTransform: "uppercase",
            color: theme.palette.text.primary,
            textAlign: "left",
            "&:hover": {
                color: theme.palette.text.secondary
            }
        }, theme.breakpoints.up("md"), {
            textAlign: "center"
        }),
        activeItem: {
            color: theme.palette.primary.main
        },
        containerInDrawer: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
        }, theme.breakpoints.up("md"), {
            display: "none"
        }),
        itemInDrawer: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
        cartIconInDrawer: {
            marginLeft: -theme.spacing(1.5)
        }
    };
});
/* harmony default export */ var Shared_NavItems = (NavItems);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js
var Link = __webpack_require__(89659);
// EXTERNAL MODULE: ./domain/constants/index.ts + 7 modules
var constants = __webpack_require__(74692);
;// CONCATENATED MODULE: ./components/layout/AnnouncementBar.tsx





var AnnouncementBar = function() {
    var classes = AnnouncementBar_useStyles();
    var ref = (0,react.useState)(false), showWrapping = ref[0], setShowWrapping = ref[1];
    (0,react.useEffect)(function() {
        setShowWrapping(Math.random() < 0.5);
    }, []);
    if (showWrapping) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.bar,
        children: "\uD83C\uDF81 Подарункове пакування для замовлень від 1000 грн та для планерів на кільцях"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/delivery",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            className: classes.bar,
            children: [
                "\uD83D\uDE9A Безкоштовна доставка від ",
                constants/* MIN_FREE_DELIVERY_PRICE */.e3,
                " грн"
            ]
        })
    });
};
var AnnouncementBar_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        bar: {
            display: "block",
            width: "100%",
            textAlign: "center",
            padding: theme.spacing(1, 2),
            backgroundColor: "rgba(156, 219, 224, 0.3)",
            color: theme.palette.text.primary,
            fontFamily: "Montserrat",
            fontWeight: 600,
            fontSize: "0.8125rem",
            transition: "background-color 200ms",
            "&:hover": {
                textDecoration: "none",
                backgroundColor: "rgba(156, 219, 224, 0.5)"
            }
        }
    };
});
/* harmony default export */ var layout_AnnouncementBar = (AnnouncementBar);

;// CONCATENATED MODULE: ./components/layout/Header.tsx










var Header = function(param) {
    var pageTitle = param.pageTitle, onOpenDrawer = param.onOpenDrawer, onOpenCart = param.onOpenCart, _hideNavigation = param.hideNavigation, hideNavigation = _hideNavigation === void 0 ? false : _hideNavigation;
    var classes = Header_useStyles();
    var width = useWidth();
    var isDesktop = width === "md" || width === "lg" || width === "xl";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar/* default */.Z, {
        position: "static",
        color: "transparent",
        className: classes.appBar,
        elevation: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_AnnouncementBar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
                className: classes.toolbar,
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: classes.toolbarContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: classes.logoContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_LinkedLogo, {
                                heigth: isDesktop ? 72 : 64,
                                width: isDesktop ? 57 : 51
                            })
                        }),
                        pageTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h1",
                            className: classes.title,
                            children: pageTitle
                        }),
                        !hideNavigation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_NavItems, {
                                    onOpenCart: onOpenCart
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    className: classes.menuButton,
                                    color: "inherit",
                                    "aria-label": "open drawer",
                                    onClick: onOpenDrawer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_CartHeaderIcon, {
                            onClick: onOpenCart,
                            className: classes.cartButton
                        })
                    ]
                })
            })
        ]
    });
};
var Header_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        title: {
            flexGrow: 1
        },
        appBar: {
            position: "relative",
            marginBottom: theme.spacing(4)
        },
        toolbar: (0,_define_property/* default */.Z)({
            paddingTop: 60
        }, theme.breakpoints.up("md"), {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        }),
        toolbarContent: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        }, theme.breakpoints.up("md"), {
            flexDirection: "row"
        }),
        logoContainer: (0,_define_property/* default */.Z)({
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            marginBottom: 0,
            marginRight: theme.spacing(4),
            flexShrink: 0
        }),
        menuButton: (0,_define_property/* default */.Z)({
            position: "absolute",
            top: theme.spacing(6),
            left: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            display: "none"
        }),
        cartButton: (0,_define_property/* default */.Z)({
            position: "absolute",
            top: theme.spacing(6),
            right: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            display: "none"
        })
    };
});
/* harmony default export */ var layout_Header = (Header);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js
var Drawer = __webpack_require__(39636);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/CloseOutlined.js
var CloseOutlined = __webpack_require__(68130);
;// CONCATENATED MODULE: ./components/layout/Drawer.tsx






var Drawer_Drawer = function(param) {
    var showDrawer = param.showDrawer, closeDrawer = param.closeDrawer, onOpenCart = param.onOpenCart;
    var classes = Drawer_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
        anchor: "left",
        open: showDrawer,
        onClose: closeDrawer,
        classes: {
            paper: classes.drawerContent
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close drawer",
                onClick: closeDrawer,
                className: classes.closeButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.logoContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_LinkedLogo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_NavItems, {
                inDrawer: true,
                onOpenCart: onOpenCart
            })
        ]
    });
};
var Drawer_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        drawerContent: {
            position: "relative",
            width: "100%",
            backgroundColor: theme.palette.common.white,
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            color: "white",
            alignItems: "flex-start"
        },
        closeButton: {
            position: "absolute",
            color: theme.palette.text.secondary,
            top: theme.spacing(1),
            right: theme.spacing(1)
        },
        logoContainer: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(4),
            width: "100%",
            display: "flex",
            justifyContent: "center"
        }
    };
});
/* harmony default export */ var layout_Drawer = (Drawer_Drawer);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
;// CONCATENATED MODULE: ./components/layout/Footer/FooterNav.tsx







var FooterNav = function() {
    var classes = FooterNav_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.container,
        children: NAV_LINKS/* NAV_LINKS.map */.q.map(function(param) {
            var href = param.href, title = param.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
                    className: classes.item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h5",
                        className: classes.title,
                        children: title
                    })
                })
            }, href);
        })
    });
};
var FooterNav_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: theme.spacing(6),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingBottom: theme.spacing(3),
            borderBottom: "2px solid ".concat(theme.palette.common.white)
        }, theme.breakpoints.up("md"), {
            paddingLeft: theme.spacing(7),
            borderBottom: "none",
            alignItems: "flex-start"
        }),
        item: (0,_define_property/* default */.Z)({
            color: theme.palette.common.white,
            marginBottom: theme.spacing(2)
        }, "&:hover", {
            color: theme.palette.primary.main
        }),
        title: {
            textTransform: "uppercase",
            fontWeight: 500
        }
    };
});
/* harmony default export */ var Footer_FooterNav = (FooterNav);

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__(51417);
// EXTERNAL MODULE: ./domain/constants/CONTACTS.ts
var CONTACTS = __webpack_require__(59919);
;// CONCATENATED MODULE: ./components/layout/Footer/Contacts.tsx








var Contacts = function() {
    var classes = Contacts_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.socialContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
                        href: CONTACTS/* CONTACTS.instagramUrl */.r.instagramUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons_index_es/* faInstagram */.Zzi,
                            size: "3x",
                            className: classes.icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
                        href: "viber://chat/?number=".concat(CONTACTS/* CONTACTS.viber */.r.viber),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons_index_es/* faViber */.oYh,
                            size: "3x",
                            className: classes.icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
                        href: "https://telegram.me/".concat(CONTACTS/* CONTACTS.telegram */.r.telegram),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons_index_es/* faTelegramPlane */.IKq,
                            size: "3x",
                            className: classes.icon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
                href: "mailto:".concat(CONTACTS/* CONTACTS.email */.r.email),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "h5",
                    variant: "h4",
                    className: classes.email,
                    children: CONTACTS/* CONTACTS.email */.r.email
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "caption",
                className: classes.address,
                children: "Україна, 81137, Львівська обл., Львівський р-н, село Пасіки-Зубрицькі"
            })
        ]
    });
};
var Contacts_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: (0,_define_property/* default */.Z)({
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4)
        }, theme.breakpoints.up("md"), {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        }),
        socialContainer: {
            display: "flex",
            justifyContent: "center",
            gap: theme.spacing(4),
            marginBottom: theme.spacing(4)
        },
        icon: {
            color: theme.palette.common.white
        },
        email: {
            color: theme.palette.common.white,
            textAlign: "center"
        },
        address: {
            color: theme.palette.common.white,
            textAlign: "center",
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            marginTop: theme.spacing(1),
            display: "block",
            maxWidth: "80%",
            margin: "auto"
        }
    };
});
/* harmony default export */ var Footer_Contacts = (Contacts);

;// CONCATENATED MODULE: ./components/layout/Footer/Copyright.tsx






var Copyright = function() {
    var classes = Copyright_useStyles();
    var year = (0,react.useMemo)(function() {
        return new Date().getFullYear();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: classes.copyrightContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_LinkedLogo, {
                white: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/oferta.pdf",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: classes.copyrightText,
                    component: "a",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "ПУБЛІЧНИЙ ДОГОВІР (ОФЕРТА)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: classes.copyrightText,
                children: [
                    "\xa9TotemNotes, ",
                    year
                ]
            })
        ]
    });
};
var Copyright_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        copyrightContainer: (_obj = {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            paddingBottom: theme.spacing(4),
            borderBottom: "2px solid ".concat(theme.palette.common.white)
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            paddingBottom: 0
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            borderBottom: "none"
        }), _obj),
        copyrightText: {
            color: theme.palette.common.white,
            marginTop: theme.spacing(2)
        }
    };
});
/* harmony default export */ var Footer_Copyright = (Copyright);

;// CONCATENATED MODULE: ./components/layout/Footer/Footer.tsx








var Footer = function(param) {
    var _hideNavigation = param.hideNavigation, hideNavigation = _hideNavigation === void 0 ? false : _hideNavigation;
    var classes = Footer_useStyles();
    if (hideNavigation) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: classes.container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                component: "footer",
                className: classes.container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Copyright, {})
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            component: "footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        className: classes.relative,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Copyright, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                className: classnames_default()(classes.divider, classes.dividerCopyright)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        className: classes.relative,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterNav, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                className: classnames_default()(classes.divider, classes.dividerNav)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 12,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Contacts, {})
                    })
                ]
            })
        })
    });
};
var Footer_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            marginTop: theme.spacing(6),
            paddingTop: theme.spacing(7.5),
            paddingBottom: theme.spacing(10),
            backgroundColor: theme.palette.primary.light
        },
        relative: {
            position: "relative"
        },
        divider: {
            backgroundColor: theme.palette.common.white,
            height: "90%",
            width: 1,
            display: "none",
            position: "absolute",
            top: "5%",
            right: 0
        },
        dividerCopyright: (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
            display: "block",
            right: theme.spacing(0.5)
        }),
        dividerNav: (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
            display: "block",
            right: -theme.spacing(0.5)
        })
    };
});
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./utils/apollo/vars/showCartVar.ts
var showCartVar = __webpack_require__(66660);
// EXTERNAL MODULE: ./components/layout/MetaTags.tsx
var MetaTags = __webpack_require__(18405);
;// CONCATENATED MODULE: ./components/layout/Layout.tsx









var Layout = function(param) {
    var children = param.children, _pageMeta = param.pageMeta, title = _pageMeta.title, description = _pageMeta.description, imageUrl = _pageMeta.imageUrl, _minimal = param.minimal, minimal = _minimal === void 0 ? false : _minimal, showTitleTag = param.showTitleTag, noindex = param.noindex;
    var theme = (0,useTheme/* default */.Z)();
    var classes = Layout_useStyles();
    var isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var ref = (0,react.useState)(false), showDrawer = ref[0], setShowDrawer = ref[1];
    (0,react.useEffect)(function() {
        if (isDesktop) setShowDrawer(false);
    }, [
        isDesktop
    ]);
    var handleCloseDrawer = function() {
        return setShowDrawer(false);
    };
    var handleOpenDrawer = function() {
        return setShowDrawer(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                title: title,
                description: description,
                imageUrl: imageUrl,
                noindex: noindex
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Header, {
                onOpenDrawer: handleOpenDrawer,
                onOpenCart: showCartVar/* openCart */.LA,
                hideNavigation: minimal
            }),
            !isDesktop && !minimal && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Drawer, {
                showDrawer: showDrawer,
                closeDrawer: handleCloseDrawer,
                onOpenCart: showCartVar/* openCart */.LA
            }),
            showTitleTag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h1",
                className: classes.title,
                children: title
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                hideNavigation: minimal
            })
        ]
    });
};
var Layout_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        title: (0,_define_property/* default */.Z)({
            textTransform: "uppercase",
            marginBottom: theme.spacing(3),
            textAlign: "center",
            fontSize: "1.75rem",
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        }, theme.breakpoints.up("md"), {
            marginBottom: theme.spacing(6),
            fontSize: "2.125rem"
        })
    };
});
/* harmony default export */ var layout_Layout = (Layout);


/***/ }),

/***/ 18405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var domain_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74692);





var truncate = function(text) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 160;
    return text.length > limit ? "".concat(text.slice(0, limit - 1).trimEnd(), "…") : text;
};
var MetaTags = function(param) {
    var title = param.title, description = param.description, imageUrl = param.imageUrl, noindex = param.noindex;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().asPath;
    var fullTitle = !title ? domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META_DATA.title */ .ql.title : title.includes(domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META_DATA.title */ .ql.title) ? title : "".concat(title, " | ").concat(domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META_DATA.title */ .ql.title);
    var metaDescription = truncate(description || domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META_DATA.description */ .ql.description);
    var metaImage = imageUrl || domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META_DATA.imageUrl */ .ql.imageUrl;
    var canonicalUrl = "".concat(domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_URL */ .FX).concat(asPath.split(/[?#]/)[0]).replace(/\/$/, "") || domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_URL */ .FX;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: fullTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex,nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: fullTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: metaImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: domain_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META_DATA.title */ .ql.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "uk_UA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: fullTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: metaImage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);


/***/ }),

/***/ 59919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ CONTACTS; }
/* harmony export */ });
var CONTACTS = {
    instagramUrl: "https://www.instagram.com/totemnotes/",
    viber: "+380636796327",
    telegram: "+380636796327",
    phoneNumber: "+380636796327",
    email: "totemnotes@gmail.com"
};


/***/ })

}]);